export enum VOCType {
  vendor = 'vendor',
  customer = 'customer'
}
